import {
  RELATIONSHIP_TO_LINK_TYPE,
  LINK_TO_RELATIONSHIP_TYPE,
} from './helpers/consts';
import markupsOnDocumentsPlugin from './markups-on-documents/index';
import markupsOnSheetsPlugin from './markups-on-sheets/index';
import { Sheet } from './types/types';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

export {
  markupsOnDocumentsPlugin,
  markupsOnSheetsPlugin,
  RELATIONSHIP_TO_LINK_TYPE,
  LINK_TO_RELATIONSHIP_TYPE,
};

const deprecatedExport: ReferencePickerPlugin<Sheet> = {
  ...markupsOnSheetsPlugin,
  getEntitiesByIds: async (options) => {
    console.warn(
      'Importing the default export from the markups plugin is deprecated! Please import markupsOnSheetsPlugin as a named export.',
    );
    return markupsOnSheetsPlugin.getEntitiesByIds(options);
  },
};
export default deprecatedExport;
